import { render } from "./BCardSubtitle.vue?vue&type=template&id=a9b65b5e&ts=true"
import script from "./BCardSubtitle.vue?vue&type=script&lang=ts"
export * from "./BCardSubtitle.vue?vue&type=script&lang=ts"

import exportComponent from "/var/lib/jenkins/workspace/Momentum/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__